import { RadioButton } from 'primereact/radiobutton';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';


const RenderQuestoesFechadas = ({questao, isQuestaoDimensionalizadaFechada, escalaAvaliativa, state, alterarEstadoIndicadorQuestoesFechadas, etapa}) => {

    if (isQuestaoDimensionalizadaFechada(questao)) {
        return (
            <DataTable id={questao.id} autoLayout={true} className="indicadores" value={questao.indicadores} stripedRows>
                <Column  class='fw-bold' field="indicador" header="Indicador" body={(rowData, index) => {
                    return (<div dangerouslySetInnerHTML={{ __html: rowData.label }}/>)
                }} />
                <Column id="id" field="id" header="Escala Avaliativa" body={(rowData, props) => {
                    return escalaAvaliativa.map((itemEscalaAvaliativa, indexItemEscalaAvaliativa) => {
                        let indicadorId = rowData.id;
                        let indicadorOptionId = indicadorId + indexItemEscalaAvaliativa;
                        return (
                            <div key={indicadorOptionId} className="p-field-radiobutton">
                                <RadioButton
                                    inputId={indicadorOptionId} //referenciação da <label> abaixo, seguindo primereact
                                    tooltipOptions={{ 'position': 'left' }} 
                                    tooltip={itemEscalaAvaliativa.descricao} 
                                    value={indexItemEscalaAvaliativa} //índice do item rendenrizado na escala avaliativa, usado como valor de seleção armazenável no estado deste radio
                                    name={indicadorId} //id do indicador para armazenamento de sua seleção, ex.:  this.state[indicadorID]
                                    checked={state[indicadorId] === indexItemEscalaAvaliativa} //analisa se o componente deve se apresentar como marcado ou não em tela
                                    onChange={(e) => { //função que seta o estado do grupo de radios de mesmo name, com o respectivo valor.
      
                                        alterarEstadoIndicadorQuestoesFechadas(indicadorId, e.value);

                                        if (etapa === 'Q') {
                                            //questoes não respondidas ficam marcadas com vermelho, ao serem respondidas, essa linha de codigo tira o nome da classe que deixa-as vermelhas
                                            document.getElementById(questao.id).querySelector(`.p-datatable-wrapper table tbody`).children[props.rowIndex].classList.remove('resposta-invalida');
                                        }
                                            
                                    }} />
                                <label htmlFor={indicadorOptionId}>{itemEscalaAvaliativa.valorQualitativo}</label>
                            </div>
                        )
                    })
                }} />
            </DataTable>
        );
    }else{
        return null;
    }

    
}
export default RenderQuestoesFechadas